module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container'"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Trino Web Console")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Teedrei")]), _vm._v(" "), _c('p', [_vm._v("Created By: "), _c('a', {
    attrs: {
      "href": "https://edwardbiton.teedrei.com"
    }
  }, [_vm._v("Edward Biton")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633b5de6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutPage.vue
// module id = 2142
// module chunks = 1